// panels/StatPanel.jsx
import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { PanelWrapper } from './PanelWrapper';

export function StatPanel({ title, value, unit = '', color = '#3b82f6', icon: Icon, trendPct, trendLabel, sparkline, description, datasource }) {
  const hasTrend = trendPct !== undefined && trendPct !== null;
  const isUp   = trendPct > 0;
  const isFlat = trendPct === 0;

  const TrendIcon = isFlat ? Minus : isUp ? TrendingUp : TrendingDown;
  const trendColor = isFlat ? 'var(--text-3)' : isUp ? '#ef4444' : '#22c55e';

  const sparkData = sparkline?.map((v, i) => ({ i, v })) || [];

  return (
    <PanelWrapper title={title} datasource={datasource}>
      <div style={{ padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 6, height: '100%' }}>
        {/* Icon + value */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
          {Icon && (
            <div style={{
              width: 32, height: 32, borderRadius: 8, flexShrink: 0,
              background: `${color}20`, display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Icon size={15} style={{ color }} />
            </div>
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              className="mono"
              style={{ fontSize: 26, fontWeight: 700, color, lineHeight: 1.1, letterSpacing: '-0.5px' }}
            >
              {value}{unit}
            </div>
            {description && (
              <div style={{ fontSize: 10, color: 'var(--text-3)', marginTop: 2 }}>{description}</div>
            )}
          </div>
        </div>

        {/* Trend */}
        {hasTrend && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <TrendIcon size={11} style={{ color: trendColor }} />
            <span style={{ fontSize: 11, color: trendColor, fontWeight: 600 }}>
              {Math.abs(trendPct).toFixed(1)}%
            </span>
            {trendLabel && (
              <span style={{ fontSize: 11, color: 'var(--text-3)' }}>{trendLabel}</span>
            )}
          </div>
        )}

        {/* Sparkline */}
        {sparkData.length > 1 && (
          <div style={{ flex: 1, minHeight: 36 }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={sparkData}>
                <Line
                  type="monotone"
                  dataKey="v"
                  stroke={color}
                  strokeWidth={1.5}
                  dot={false}
                  strokeOpacity={0.8}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </PanelWrapper>
  );
}
